<template>
  <div class="newsMain">
    <PcTms class="PC"/>
    <MdTms class="MD"/>
  </div>
</template>

<script>
// 移动端
import MdTms from './MdTms.vue'
// pc端
import PcTms from './PcTms.vue'
export default {
  name: 'newsMain',
  components: {
    PcTms,
    MdTms
  }
}
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .newsMain{
    .PC{
      display: none;
    }
  }

}
// PC端/
@media only screen and (min-width: 756px) {
  .newsMain{
    .MD{
      display: none;
    }
  }
}
</style>
